// extracted by mini-css-extract-plugin
export default {"gur_main_content":"styles_gur_main_content__XYtGS"};